export const sendClientToolResult = async (apiClient, {agentTaskId, toolUseId, result}) => {
  return apiClient.post("/v1/maestro/client-tool-result", {
    agentTaskId,
    toolUseId,
    result,
  });
};
